import FormattedMessage from 'I18n/components/FormattedMessage';
import { getIsInactive, getIsPublished } from 'quotes-ui-lib/utils/status';
import { getQuoteProperty } from '../utils/quote';
import { Button } from 'foundations-components/transitional/components/Button';
import { useCallback, useEffect } from 'react';
import Raven from 'raven-js';
import { jsx as _jsx } from "react/jsx-runtime";
const SendButton = ({
  setShareQuoteModalOpen,
  loadContacts,
  isContactsLoading,
  trackAction
}) => {
  useEffect(() => {
    loadContacts().catch(Raven.captureException);
  }, [loadContacts]);
  const handleOnClick = useCallback(() => {
    setShareQuoteModalOpen(true);
    trackAction('Send quote');
  }, [trackAction, setShareQuoteModalOpen]);
  return /*#__PURE__*/_jsx(Button, {
    "data-test-id": "send-btn",
    "data-selenium-test": "send-btn",
    use: "tertiary-light",
    responsive: false,
    size: "extra-small",
    onClick: handleOnClick,
    disabled: isContactsLoading,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      "data-test-id": "send-btn-text",
      message: "quotesUiLib.quoteActions.send.buttonText"
    })
  }, "sendButton");
};
export default SendButton;
export const showSendButton = (quote, userOwnerId) => {
  const isInactive = getIsInactive(quote);
  const isPublished = getIsPublished(quote);
  const isPublishedAndActive = isPublished && !isInactive;
  if (getQuoteProperty(quote, 'hs_approver_id')) {
    return isPublishedAndActive && Number(getQuoteProperty(quote, 'hs_approver_id')) === userOwnerId;
  }
  return isPublishedAndActive;
};